const defaultStyle = {
  backgroundImage: "url(/jashindp/background.png)",
  backgroundSize: "100% auto",
  backgroundRepeat: "repeat",
  backgroundPosition: "top center",
};

const backgroundStyles = {
  Tickets: defaultStyle,
  MyPage: defaultStyle,
  Quests: defaultStyle,
  HowToUse: defaultStyle,
  News: defaultStyle,
  EmailSettings: defaultStyle,
  ConfirmPayPay: defaultStyle,
  CheckPayPayStatus: defaultStyle,
  PayPayPolling: defaultStyle,
  PayPayConfirm: defaultStyle,
  Halloween: {
    backgroundImage: "url(/jashindp/halloween/pattern.webp)",
    backgroundRepeat: "repeat", // 繰り返す
    backgroundSize: "100% auto", // 横幅を要素に合わせ、高さは比率維持
    backgroundPosition: "top center",
  },
};

export default backgroundStyles;
